import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-manage-integration',
  templateUrl: './manage-integration.component.html',
  styleUrls: ['./manage-integration.component.scss']
})
export class ManageIntegrationComponent implements OnInit {

  constructor(private dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  addFolder(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'inteModal'
    });   
  }
  


}
